import {z} from 'zod';
import {CategorySchema} from '../../fields/enrichment';
import {ApiDefinition} from '../definitions';
import {ObjectIdSchema} from '../../zod';

export const GenerateSegments = {
  path: 'ai/generateSegments',
  method: 'post',
  options: {access: 'admin'},
  requestDataSchema: z.object({
    domain: z.string(),
    testListId: ObjectIdSchema,
  }),
  responseDataSchema: z.object({
    taskId: ObjectIdSchema,
  }),
} satisfies ApiDefinition;

export const GetSegments = {
  path: 'ai/getSegments',
  method: 'get',
  options: {access: 'admin'},
  requestDataSchema: z.object({
    previousResponseId: z.string(),
  }),
  responseDataSchema: z.object({
    segments: CategorySchema.array(),
  }),
} satisfies ApiDefinition;
